import { useState } from "react";
import { Button } from "@/components/ui/button";

const CLS = { ok: "text-emerald-700", duplicate: "text-amber-700", unknown: "text-amber-700 bg-amber-50" };

export default function MappingReport({ draft, fields, onRemap }) {
  const [open, setOpen] = useState(false);
  const [cols, setCols] = useState(draft.columns);
  const miss = draft.missing_required || [];
  return (
    <div className="panel p-3 text-[13px]" data-testid="bankrecon-mapping-report">
      <div className="flex items-center gap-3">
        <b>Sütun eşleme raporu</b><span className="text-slate-500">başlık satırı {draft.header_row + 1}</span>
        {miss.length > 0 && <span className="text-rose-600" data-testid="bankrecon-missing">Eksik: {miss.map((m) => m.field_label).join(", ")}</span>}
        <Button size="sm" variant="outline" className="ml-auto" onClick={() => setOpen(!open)} data-testid="bankrecon-mapping-toggle">{open ? "Kapat" : "Eşlemeyi düzenle"}</Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {draft.mapping_report.map((c) => <span key={c.index} className={`rounded border px-2 py-0.5 ${CLS[c.status]}`} title={c.message} data-testid={`bankrecon-col-${c.col}`}>{c.col}: {c.header} → {c.field_label || "tanınmadı"}</span>)}
      </div>
      {open && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
          {Object.entries(fields).map(([k, l]) => (
            <label key={k} className="text-[12px]">{l}
              <select className="h-8 w-full rounded border px-1" value={cols[k] ?? ""} onChange={(e) => setCols({ ...cols, [k]: e.target.value === "" ? undefined : Number(e.target.value) })} data-testid={`bankrecon-map-${k}`}>
                <option value="">—</option>{draft.headers.map((h, i) => <option key={i} value={i}>{String.fromCharCode(65 + (i % 26))}: {h}</option>)}
              </select></label>))}
          <Button size="sm" className="self-end" onClick={() => onRemap({ header_row: draft.header_row, columns: cols })} data-testid="bankrecon-remap">Bu eşlemeyle yeniden oku</Button>
        </div>)}
    </div>
  );
}
